import { BatchesService } from '@festina/unitlinkdatareplicator-general-types/unitlinkdatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
export type MethodParam = NonNullable<
  Parameters<typeof method>[0]['requestBody']
>

export const useSubmitUnitlinkDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'unitLinkDataReplicator',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
